// extracted by mini-css-extract-plugin
export default {"btn":"modal_btn__TTQVU","backdrop":"modal_backdrop__RKldJ","modal":"modal_modal__e093m","mobile-icon":"modal_mobile-icon__zoY+F","modal-header":"modal_modal-header__4mIvf"};